'use es6';

import { isHubSpotter, isForceOpen, warn } from '../utils';
import translations from '../wootric-translations';
import * as UserAttributes from '../sources/UserAttributes';
const csatTokenQA = 'NPS-3489af5b';
const csatTokenProd = 'NPS-61a7bd63';
export const SurveyKeys = {
  ACCOUNTS_AND_BILLING: 'ACCOUNTS_AND_BILLING',
  WORKFLOWS: 'WORKFLOWS',
  INBOX: 'INBOX',
  CMS_BRAND_SETTINGS: 'CMS_BRAND_SETTINGS',
  CMS_CONTENT_DETAIL: 'CMS_CONTENT_DETAIL',
  CMS_DESIGN_MANAGER: 'CMS_DESIGN_MANAGER',
  ADVANCED_BUILDER: 'ADVANCED_BUILDER',
  FORECASTING: 'FORECASTING',
  FORECASTING_SEPG: 'FORECASTING_SEPG',
  SOCIAL: 'SOCIAL',
  MARKETING_EMAIL: 'MARKETING_EMAIL',
  FORMS: 'FORMS',
  CAMPAIGNS: 'CAMPAIGNS',
  INDEX_CRM: 'INDEX_CRM',
  RECORD_CRM: 'RECORD_CRM',
  DEAL: 'DEAL',
  ADS: 'ADS',
  TASKS: 'TASKS',
  SEQUENCES: 'SEQUENCES',
  QUOTES: 'QUOTES',
  ANALYTICS: 'ANALYTICS',
  CHAT: 'CHAT',
  DATA_SYNC: 'DATA_SYNC',
  CRM_LISTS: 'CRM_LISTS',
  CRM_SETTINGS: 'CRM_SETTINGS',
  PAYMENTS: 'PAYMENTS',
  ADMIN_SETUP: 'ADMIN_SETUP',
  IMPORT: 'IMPORT',
  ADMIN_GOVERNANCE: 'ADMIN_GOVERNANCE',
  SINGLE_REPORT_VIEWER: 'SINGLE_REPORT_VIEWER',
  REPORT_LIBRARY: 'REPORT_LIBRARY',
  JOURNEY_ANALYTICS: 'JOURNEY_ANALYTICS',
  SINGLE_OBJECT_BUILDER: 'SINGLE_OBJECT_BUILDER',
  MULTI_TOUCH_ATTRIBUTION: 'MULTI_TOUCH_ATTRIBUTION',
  REPORT_DASHBOARD_VIEW: 'REPORT_DASHBOARD_VIEW',
  PROSPECTING_MEETINGS: 'PROSPECTING_MEETINGS',
  PROSPECTING_MANAGE_SEQUENCES: 'PROSPECTING_MANAGE_SEQUENCES',
  PROSPECTING_TASKS: 'PROSPECTING_TASKS',
  SALES_EXECUTION_DEAL_PIPELINE: 'SALES_EXECUTION_DEAL_PIPELINE',
  SALES_EXECUTION_DEALS: 'SALES_EXECUTION_DEALS',
  PROSPECTING_WORKSPACE: 'PROSPECTING_WORKSPACE',
  CSAT_SVH_KNOWLEDGEBASE: 'CSAT_SVH_KNOWLEDGEBASE',
  CSAT_SVH_HELPDESK: 'CSAT_SVH_HELPDESK',
  CSAT_SVH_TICKET_DEFAULTS: 'CSAT_SVH_TICKET_DEFAULTS',
  CSAT_SVH_HELPDESK_USER: 'CSAT_SVH_HELPDESK_USER',
  CSAT_SVH_LIVE_CHAT: 'CSAT_SVH_LIVE_CHAT',
  CSAT_SVH_BOT_MESSENGER: 'CSAT_SVH_BOT_MESSENGER',
  CSAT_CRM_CONNECTED_APPS: 'CSAT_CRM_CONNECTED_APPS',
  CSAT_CRM_CREATE_CUSTOM_OBJECT: 'CSAT_CRM_CREATE_CUSTOM_OBJECT',
  CSAT_CRM_VIEW_CUSTOM_OBJECTS: 'CSAT_CRM_VIEW_CUSTOM_OBJECTS',
  PRODUCTS: 'PRODUCTS',
  INVOICES: 'INVOICES',
  CMS_SEO_RECS: 'CMS_SEO_RECS',
  FILE_MANAGER_PAGE_VIEW: 'FILE_MANAGER_PAGE_VIEW',
  COMMERCE_SUBSCRIPTIONS: 'COMMERCE_SUBSCRIPTIONS',
  ECOSYSTEM_ACADEMY: 'ECOSYSTEM_ACADEMY',
  PAYMENT_LINKS: 'PAYMENT_LINKS',
  ECOSYSTEM_APP_MARKETPLACE: 'ECOSYSTEM_APP_MARKETPLACE',
  ECOSYSTEM_NETWORK: 'ECOSYSTEM_NETWORK',
  DATASETS: 'DATASETS',
  CTAS: 'CTAS',
  DATA_QUALITY: 'DATA_QUALITY'
};
const SurveyConfig = {
  [SurveyKeys.ACCOUNTS_AND_BILLING]: {
    event_name: 'AccountVisit'
  },
  [SurveyKeys.WORKFLOWS]: {
    event_name: 'workflows_visit'
  },
  [SurveyKeys.INBOX]: {
    event_name: 'inbox_visit'
  },
  [SurveyKeys.CMS_BRAND_SETTINGS]: {
    event_name: 'brand_settings'
  },
  [SurveyKeys.CMS_CONTENT_DETAIL]: {
    event_name: 'content_pageview'
  },
  [SurveyKeys.CMS_DESIGN_MANAGER]: {
    event_name: 'designmanager_editor'
  },
  [SurveyKeys.ADVANCED_BUILDER]: {
    event_name: 'open_filters'
  },
  [SurveyKeys.FORECASTING]: {
    event_name: 'forecasting_pageview'
  },
  [SurveyKeys.FORECASTING_SEPG]: {
    event_name: 'forecast_pageview'
  },
  [SurveyKeys.SOCIAL]: {
    event_name: 'social_manage'
  },
  [SurveyKeys.MARKETING_EMAIL]: {
    event_name: 'email_pageview'
  },
  [SurveyKeys.FORMS]: {
    event_name: 'form_pageview'
  },
  [SurveyKeys.CAMPAIGNS]: {
    event_name: 'campaigns_details'
  },
  [SurveyKeys.DEAL]: {
    event_name: 'deal_preview'
  },
  [SurveyKeys.ADS]: {
    event_name: 'ads_pageview'
  },
  [SurveyKeys.TASKS]: {
    event_name: 'create_task'
  },
  [SurveyKeys.SEQUENCES]: {
    event_name: 'sequence_pageview'
  },
  [SurveyKeys.QUOTES]: {
    event_name: 'quotes_pageview'
  },
  [SurveyKeys.ANALYTICS]: {
    event_name: 'analytics_nav'
  },
  [SurveyKeys.INDEX_CRM]: {
    event_name: 'open_saved_view'
  },
  [SurveyKeys.RECORD_CRM]: {
    event_name: 'pin_engagement'
  },
  [SurveyKeys.CHAT]: {
    event_name: 'chat_pageview'
  },
  [SurveyKeys.DATA_SYNC]: {
    event_name: 'save_sync'
  },
  [SurveyKeys.CRM_LISTS]: {
    event_name: 'save_list'
  },
  [SurveyKeys.CRM_SETTINGS]: {
    event_name: 'save_property'
  },
  [SurveyKeys.PAYMENTS]: {
    event_name: 'payments_sidebar'
  },
  [SurveyKeys.ADMIN_SETUP]: {
    event_name: 'create_new_user'
  },
  [SurveyKeys.IMPORT]: {
    event_name: 'finish_import'
  },
  [SurveyKeys.ADMIN_GOVERNANCE]: {
    event_name: 'admin_governance'
  },
  [SurveyKeys.SINGLE_REPORT_VIEWER]: {
    event_name: 'single_report_view'
  },
  [SurveyKeys.REPORT_LIBRARY]: {
    event_name: 'report_library_view'
  },
  [SurveyKeys.JOURNEY_ANALYTICS]: {
    event_name: 'journey_builder_pageview'
  },
  [SurveyKeys.SINGLE_OBJECT_BUILDER]: {
    event_name: 'open_single_object_builder'
  },
  [SurveyKeys.MULTI_TOUCH_ATTRIBUTION]: {
    event_name: 'mt_attribution'
  },
  [SurveyKeys.REPORT_DASHBOARD_VIEW]: {
    event_name: 'report_dashboard_view'
  },
  [SurveyKeys.PROSPECTING_MEETINGS]: {
    event_name: 'meeting_usage'
  },
  [SurveyKeys.PROSPECTING_MANAGE_SEQUENCES]: {
    event_name: 'sequence_usage'
  },
  [SurveyKeys.PROSPECTING_TASKS]: {
    event_name: 'start_task_queue'
  },
  [SurveyKeys.SALES_EXECUTION_DEAL_PIPELINE]: {
    event_name: 'dealboard_view'
  },
  [SurveyKeys.SALES_EXECUTION_DEALS]: {
    event_name: 'deal_index_view'
  },
  [SurveyKeys.PROSPECTING_WORKSPACE]: {
    event_name: 'prospecting_pageview'
  },
  [SurveyKeys.CSAT_SVH_KNOWLEDGEBASE]: {
    event_name: 'knowledgebase_article_insights'
  },
  [SurveyKeys.CSAT_SVH_HELPDESK]: {
    event_name: 'helpdesk_ticket_closed'
  },
  [SurveyKeys.CSAT_SVH_TICKET_DEFAULTS]: {
    event_name: 'helpdesk_ticket_defaults'
  },
  [SurveyKeys.CSAT_SVH_HELPDESK_USER]: {
    event_name: 'add_helpdesk_user'
  },
  [SurveyKeys.CSAT_SVH_LIVE_CHAT]: {
    event_name: 'chatflows_live_chat'
  },
  [SurveyKeys.CSAT_SVH_BOT_MESSENGER]: {
    event_name: 'chatflows_messenger'
  },
  [SurveyKeys.CSAT_CRM_CONNECTED_APPS]: {
    event_name: 'connected_apps'
  },
  [SurveyKeys.CSAT_CRM_CREATE_CUSTOM_OBJECT]: {
    event_name: 'create_custom_object'
  },
  [SurveyKeys.CSAT_CRM_VIEW_CUSTOM_OBJECTS]: {
    event_name: 'view_custom_objects'
  },
  [SurveyKeys.PRODUCTS]: {
    event_name: 'products_index'
  },
  [SurveyKeys.INVOICES]: {
    event_name: 'invoices_index'
  },
  [SurveyKeys.CMS_SEO_RECS]: {
    event_name: 'seo_recs'
  },
  [SurveyKeys.FILE_MANAGER_PAGE_VIEW]: {
    event_name: 'files_homepage'
  },
  [SurveyKeys.COMMERCE_SUBSCRIPTIONS]: {
    event_name: 'subscriptions_index'
  },
  [SurveyKeys.ECOSYSTEM_ACADEMY]: {
    event_name: 'academy_content_progress'
  },
  [SurveyKeys.PAYMENT_LINKS]: {
    event_name: 'payment_links_index'
  },
  [SurveyKeys.ECOSYSTEM_APP_MARKETPLACE]: {
    event_name: 'app_marketplace'
  },
  [SurveyKeys.ECOSYSTEM_NETWORK]: {
    event_name: 'connect_interaction'
  },
  [SurveyKeys.DATASETS]: {
    event_name: 'datasets_pageview'
  },
  [SurveyKeys.CTAS]: {
    event_name: 'cta_pageview'
  },
  [SurveyKeys.DATA_QUALITY]: {
    event_name: 'data_quality_interaction'
  }
};
export const getConfig = (token, props = {}, surveyKey) => {
  const {
    field_required,
    permission_labels,
    customMessages: overrideMessages,
    complete,
    supported
  } = translations;
  const lang = supported[props.language] ? props.language : 'EN'; // Wootric doesn't support translating custom messages for other languages:
  // http://docs.wootric.com/javascript/#custom-language-setting
  // So we have to build our own light translation setup here

  let wootricTarget;
  let customMessages = {};
  let translatedConfig = {};
  const surveysWithLegacyFollowUpQuestion = [SurveyKeys.ACCOUNTS_AND_BILLING, SurveyKeys.WORKFLOWS, SurveyKeys.INBOX, SurveyKeys.FORECASTING, SurveyKeys.SOCIAL, SurveyKeys.MARKETING_EMAIL, SurveyKeys.FORMS, SurveyKeys.CAMPAIGNS, SurveyKeys.DEAL, SurveyKeys.ADS, SurveyKeys.TASKS, SurveyKeys.SEQUENCES, SurveyKeys.QUOTES, SurveyKeys.ANALYTICS, SurveyKeys.CHAT, SurveyKeys.DATA_SYNC, SurveyKeys.CRM_LISTS, SurveyKeys.CRM_SETTINGS, SurveyKeys.PAYMENTS, SurveyKeys.ADMIN_SETUP, SurveyKeys.ADMIN_GOVERNANCE, SurveyKeys.DATA_QUALITY];

  if (complete[lang]) {
    const {
      csat_questions,
      followup_question,
      followup_question_nps,
      followup_thank_you,
      placeholder_text,
      wootric_recommend_target
    } = overrideMessages[lang];
    wootricTarget = wootric_recommend_target;
    customMessages = {
      followup_question: surveysWithLegacyFollowUpQuestion.includes(surveyKey) ? followup_question : followup_question_nps,
      followup_thank_you,
      placeholder_text
    };

    if (csat_questions && csat_questions[surveyKey]) {
      customMessages.csat_question = csat_questions[surveyKey];

      if (props['properties']) {
        props['properties']['question'] = customMessages.csat_question;
      }
    }
  }

  translatedConfig = {
    field_required,
    permission_labels,
    wootric_recommend_target: wootricTarget
  };
  const wootricSettings = Object.assign({}, props, {
    account_token: token,
    ask_permission_to_share_feedback: true,
    // this generates the checkbox (pre-checked)
    modal_footprint: 'normal',
    callbacks: {
      after_show: config => {
        UserAttributes.touch('nav:seen');

        if (config && config.localized_texts && translations.complete[props.language]) {
          try {
            config.localized_texts.send = translations.customMessages[props.language].send;
          } catch (e) {
            warn(`Could not set localized "Send" text for language: ${props.language}; message: ${e.message}`);
          }
        }
      },

      after_decline() {
        UserAttributes.touch('nav:declined');
      },

      after_response() {
        UserAttributes.touch('nav:responded');
      }

    }
  }, translatedConfig);
  return {
    customMessages,
    wootricSettings
  };
};
export const configureCsat = (props, surveyKey) => {
  const {
    event_name
  } = SurveyConfig[surveyKey];

  if (event_name) {
    props.event_name = event_name;
  }

  const token = isHubSpotter(props.email) ? csatTokenQA : csatTokenProd;

  if (isForceOpen()) {
    window.wootric_no_surveyed_cookie = true;
    console.debug('"wootric-nps-open" flag is set.', 'Wootric should be forced open.', 'Disregard the message it gives saying "remove survey immediately".');
  } // seconds to delay before opening (default 10)


  window.wootric_time_delay = 1;
  const {
    wootricSettings,
    customMessages
  } = getConfig(token, props, surveyKey);
  window.customMessages = customMessages;
  window.wootricSettings = wootricSettings;
};